import React, { Component } from 'react'
import UserInfo from './UserInfo'
import UserIconList from './UserIconList'
import Request from '../request'
/**
 * 用户中心组件
 */
class LoginCenter extends Component {
    static defaultProps = {
      data: [{
        url: '//ding.youku.com/u/subscribeUpdate',
        title: '我的追剧',
        className: 'u-watch'

      }, {
        url: '//faxian.youku.com/favorite',
        title: '我的收藏',
        className: 'u-collect'

      }, {
        url: '//i.youku.com/i/profile',
        title: '我的自频道',
        className: 'u-zpd'

      }, {
        url: '//creation.youku.com',
        title: '创作中心',
        className: 'u-center'

      }],
      accountSetUrl: '//user.youku.com/page/setting/base_profile'
    }
    constructor (props) {
      super(props)
      this.state = {
        hoverClass: 'dropdown',
        userInfoOk: false,
        isLogin: false,
        vipInfoOk: false
      }
      this.isRequesting = false
      this.userInfo = {}
      this.vipInfo = {}
      this.state.isLogin = this.props.Login.isLogin()
      this.handleMouseEnter = this.handleMouseEnter.bind(this)
      this.handleMouseLeave = this.handleMouseLeave.bind(this)
    }

    componentDidMount () {
      // 绑定登录回调事件
      this.props.Login.checkLogin((isLogin, userInfo) => {
        this.userInfo = userInfo
        this.setState({
          userInfoOk: true,
          isLogin: isLogin
        })
        if (this.userInfo.vip) {
          this.getVipInfo()
        }
      })
    }

    getVipInfo () {
      if (!this.state.vipInfoOk && !this.isRequesting) {
        this.isRequesting = true
        Request.getValidMemeberInfo((data) => {
          if (data && data.code === '20000' && data.result) {
            for (const key in data.result) {
              this.vipInfo[key] = data.result[key]
            }
            // this.vipInfo = data.result
            this.vipInfoOk = true
          }
        })

        Request.getVipGrade((data) => {
          if (data.errno === 0 && data.errmsg === 'success' && data.data) {
            for (const key in data.data) {
              this.vipInfo[key] = data.data[key]
            }
          }
          this.isRequesting = false
        })
      }
    }
    handleMouseEnter (e) {
      this.setState({
        hoverClass: 'dropdown-open'
      })
    }

    handleMouseLeave () {
      this.setState({
        hoverClass: ''
      })
    }

    login (e) {
      this.props.Login.login()
      e.preventDefault()
    }

    logout () {
      this.props.Login.logout()
    }

    render () {
      let _html
      if (!this.state.isLogin || !this.state.userInfoOk) {
        _html = (
          <div className={`login-before dropdown ${this.state.hoverClass}`} style={{ display: 'block' }}>
            <a href='javascript:void(0);' id='qheader_login' onClick={this.login.bind(this)}>
              <img className='avatar' src='//img.alicdn.com/tfs/TB1.0VvChjaK1RjSZFAXXbdLFXa-80-80.png' />
            </a>
            <div className='panel u-panel'>
              <i className='arrow' />
              <div className='content'>
                <span>登录使用更多功能</span>
              </div>
              <div className='u-bottom-singin'>
                <a href='javascript:void(0);' target='_blank' className='singin' id='qheader_panel-login' onClick={this.login.bind(this)}>登录/注册</a>
              </div>
            </div>
          </div>
        )
      } else {
        _html = (
          <div className={`login-after dropdown ${this.state.hoverClass}`} style={{ display: 'block' }}>
            <a className='a-avatar' href={`//i.youku.com/i/ ${this.userInfo.encodeUid}`} target='_blank' rel='noopener noreferrer'>
              <img className='avatar' title={this.userInfo.username} alt={this.userInfo.username} src={this.userInfo.avatar.large} />
              {
                this.vipInfo && this.vipInfo.icon ? <span className='vip-level-icon' style={{ backgroundImage: `url(${this.vipInfo.icon})` }} /> : ''
              }
            </a>
            <div className='panel u-panel'>
              <i className='arrow' />
              <div className='content'>
                <div className='u-content'>
                  <UserInfo userInfo={this.userInfo} vipInfo={this.vipInfo} />
                  <UserIconList data={this.props.data} />
                </div>
              </div>
              <div className='u-bottom'>
                <a href='javascript:void(0);' className='singout' alt='退出登录' onClick={this.logout.bind(this)}>退出登录</a>
                <a href={this.props.accountSetUrl} target='_blank' rel='noopener noreferrer'>账户设置</a>
              </div>
            </div>
          </div>
        )
      }
      return (
        <div className='u-login'
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}>
          {_html}
        </div>
      )
    }
}
export default LoginCenter
